import actionTypes from '../../../redux/actions/action-types';

export const setAction = (data) => ({
  type: actionTypes.teamInvitationsPage.set,
  data,
});

export const getInvitationsAction = (data) => ({
  type: actionTypes.teamInvitationsPage.getInvitations,
  data,
});

export const deleteInvitationAction = (data) => ({
  type: actionTypes.teamInvitationsPage.deleteInvitation,
  data,
});

export const deleteInvitationsAction = (data) => ({
  type: actionTypes.teamInvitationsPage.deleteInvitations,
  data,
});

export const setInvitationsAction = (data) => ({
  type: actionTypes.teamInvitationsPage.setInvitations,
  data,
});

export const resendInvitationAction = (data) => ({
  type: actionTypes.teamInvitationsPage.resendInvitation,
  data,
});

export const getPlanDetailsAction = (data) => ({
  type: actionTypes.teamInvitationsPage.getPlanDetails,
  data,
});
